export default __webpack_public_path__ + "static/map-ca520cdd87d96c448ae0cf5ba0887c65.png";